
import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getSalesByStatus } from '../../../actions/inventoryActions'
import { Table } from '../../../admin/components/Table/Table'
import { SaleRegister } from '../../../assets/icons'
import { Translate } from '../../../language'
import TitleImg from '../../../utils/components/TitleImg/TitleImg'
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import { formatPrice } from '../../../utils/functions'
import SaleMadeImg from     '../../../assets/img/sale_made.png';
import Button from '../../../utils/components/Button/Button'

const InventorySales = () => {
  const { userInfo } = useSelector(state => state.userInfo)
  const { sales } = useSelector(state => state.inventory)
  const [status, setStatus] = useState(0)
  const dispatch = useDispatch()
  useEffect(() => {
    let type = "";
    let id = "";
    if (userInfo.representativeID) {
      if (userInfo.representativeID.state ===2) {

        id = userInfo.representativeID._id
      }
    }
    if (userInfo.franchiseID) {
      if (userInfo.franchiseID.state ===2) {

        id = userInfo.franchiseID._id
      }
    }
    if (userInfo.warehouseID) {

      id = userInfo.warehouseID

    }
    if (id != '') {
      dispatch(getSalesByStatus(id, status))
    }


    return () => {

    }
  }, [userInfo, status])

  return (
    <div>
      <TitleImg img={SaleMadeImg} titleHighlight="" title={Translate('inventorySales', 'es')} />
      <div className='column column-gap mt-4 mb-5'>
        <Button active={status===0} onClick={()=>setStatus(0)} text='Pendiente'/>
        <Button active={status===1} onClick={()=>setStatus(1)}  text='Entregado'/>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Codigo</th>
            <th>Fecha</th>
            <th>Valor total</th>
            <th>Ver detalle</th>
          </tr>
        </thead>
        <tbody>
          {
            sales.map(sale => (
              <tr key={sale._id}>
                <td>{sale.code}</td>
                <td>{new Date(sale.creationDate).toLocaleDateString()}</td>
                <td>{formatPrice(sale.totalPrice)}</td>
                <td>{
                  <Link to={`/Inventory/sale/${sale._id}`} >Ir</Link>
                }</td>


              </tr>
            ))
          }
        </tbody>

      </Table>
    </div>
  )
}

export default InventorySales